import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Container, Content, FlexboxGrid, Icon, Input, InputGroup, Notification } from 'rsuite';
import { LoadingSpiner } from '../../../components/LoadingSpinner';
import { NewFilters } from './Cadastro/Filters/NewFilters';
import { TableCampaignRegister } from './Cadastro/Table/TableCampaignRegister';
import { CampaignTypeDeleteModal } from './Components/Modals/ConfirmDeleteCampaignModal';
import { useCampaign } from './hooks/useCampaign';
import { deleteCampanha } from './services';

const CampanhasV2 = ({ history }) => {
  const queryClient = useQueryClient();

  const { filters, handlers, states } = useCampaign();
  const { campaignName, campaigns, sort } = states;
  const { setCampaignName, setSort, setPage, setSize } = handlers;

  const [showModalConfirmacaoExclusao, setShowModalConfirmacaoExclusao] = useState(false);
  const [campanhaToDelete, setCampanhaToDelete] = useState(null);

  const goNovaCampanha = () => {
    history.push('/ipa/campanhas/cadastro/dados-campanha');
  };

  const closeExclusao = () => {
    setShowModalConfirmacaoExclusao(false);
    setCampanhaToDelete(null);
  };

  const confirmExclusao = () => {
    deleteCampanha(campanhaToDelete).then(() => {
      Notification.success({
        title: 'Notificação',
        duration: 6000,
        description: (
          <div>
            <p>Campanha excluída com sucesso.</p>
          </div>
        ),
      });
      closeExclusao();
      queryClient.invalidateQueries(['campaigns']);
    });
  };

  const removeCampanha = id => {
    setShowModalConfirmacaoExclusao(true);
    setCampanhaToDelete(id);
  };

  const editCampanha = id => {
    history.push(`/ipa/campanhas/cadastro/dados-campanha/${id}`);
  };

  return (
    <Container className="main-container campanhas-page">
      <Content className="secao-busca">
        <FlexboxGrid align="middle">
          <FlexboxGrid.Item colspan={24}>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <h4 className="campanhas-title">Campanhas</h4>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item componentClass={Col} lg={16} md={15} sm={14} xs={4}>
                <InputGroup inside className="input-outline">
                  <InputGroup.Addon>
                    <Icon className="icon-busca" icon="search" />
                  </InputGroup.Addon>
                  <Input placeholder="Pesquise por uma campanha" value={campaignName} onChange={value => setCampaignName(value)} />
                  {campaignName ? (
                    <InputGroup.Addon>
                      <Icon icon="close" onClick={() => setCampaignName('')} />
                    </InputGroup.Addon>
                  ) : null}
                </InputGroup>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Button id="nova-campanha" title="Nova regra" block appearance="primary" onClick={goNovaCampanha}>
                  NOVA CAMPANHA
                </Button>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
      <Content className="secao-filtros">
        <NewFilters {...filters} />
      </Content>
      <Content className="secao-tabela">
        <LoadingSpiner size="md" />
        <div className="campanhas-table-container">
          <TableCampaignRegister
            editCampanha={editCampanha}
            removeCampanha={removeCampanha}
            campaigns={campaigns}
            sort={sort}
            setSort={setSort}
            setPage={setPage}
            setSize={setSize}
          />
        </div>
      </Content>

      <CampaignTypeDeleteModal open={showModalConfirmacaoExclusao} onCancel={closeExclusao} onConfirm={confirmExclusao} />
    </Container>
  );
};

export default withRouter(CampanhasV2);
